export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/[0.06] py-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.22em] text-zinc-500">
        <span data-testid="footer-copy">
          © {year} dr. Mohammad Bintang Bis Cirurgiputra
        </span>
        <span>Designed &amp; built with quiet intent.</span>
        <a
          href="#top"
          data-testid="footer-back-to-top"
          className="hover:text-white transition-colors"
        >
          Back to top ↑
        </a>
      </div>
    </footer>
  );
}
